<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="400px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      Edit NauSys Integration Settings
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text class="pa-6">
      <v-row
        no-gutters
        class="body-1"
        align="center"
      >
        <v-col>
          Enter NauSys Yacht IDs
        </v-col>
        <v-col cols="auto">
          <v-btn
            color="secondary"
            text
            @click="ids.push('')"
          >
            <v-icon
              left
              small
            >
              fa fa-plus
            </v-icon>
            Add
          </v-btn>
        </v-col>
      </v-row>
      <v-text-field
        v-for="(id, index) in ids"
        :key="'nausys_' + index"
        v-model="ids[index]"
        outlined
        hide-details
        class="mb-2"
        clearable
        placeholder="1234567"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
import Yacht from '@/models/Yacht'
import ContentDialog from '@/components/helpers/Dialog'

export default {
  name: 'YachtBookingIntegrationSettingsDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        ids: [null],
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
  watch: {
    visible(value) {
      if (!value) return

      this.ids = [...this.yacht.nausys_ids]
    }
  },
    methods: {
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.saveYacht()
      },
      async saveYacht() {
        this.submitting = true

        let formData = {
          nausys_ids: this.ids.filter(id => !!id)
        }

        try {
          let savedYacht = await Yacht.api.save(formData, this.yacht.id)

          this.$store.dispatch('alert', {
            'text': 'Details saved',
            'color': 'success'
          })
          this.$emit('update:yacht', savedYacht)
          this.modalVisible = false
        } catch (e) {
          if (e.response && e.response.status === 422) {
            this.$store.dispatch('alert', {
              'text': e.response.data.message,
              'color': 'warning'
            })
          } else {
            this.$store.dispatch('alert', {
              'text': 'Something went wrong',
              'color': 'error'
            })
          }

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
